// Standard Snowbird Industries environment banner (sticky Dev/Beta bar).
export default function EnvBanner() {
  if (typeof window === 'undefined') return null
  const host = window.location.hostname
  const env =
    host === 'beta.snowbirdindustries.us' || host.startsWith('beta-')
      ? { label: 'Beta', color: '#6366f1' }
      : host === 'dev.snowbirdindustries.us' || host.startsWith('dev-') || host === 'localhost' || host === '127.0.0.1'
      ? { label: 'Dev', color: '#f59e0b' }
      : null
  if (!env) return null
  return (
    <div style={{ position: 'sticky', top: 0, zIndex: 2147483647, width: '100%', height: 24, lineHeight: '24px', background: env.color, color: '#fff', textAlign: 'center', fontSize: '0.7rem', fontWeight: 700, letterSpacing: '0.12em', textTransform: 'uppercase' }}>
      {env.label} Environment
    </div>
  )
}
